<template>
  <div class="paid-page">
    <!-- ロゴ -->
    <div class="text-center logo-area">
      <img class="logo" src="@/assets/img/header_logo.png" alt="新学社">
    </div>

    <v-row class="ma-0" justify="center">
      <v-col cols="12" md="8" lg="6" align="center">
        <div class="panel">
          <h2 class="panel-heading">有料版アカウント登録</h2>

          <v-card class="paid-card pa-10 elevation-10">
            <p class="paid-text">
              有料用紙印刷を希望される場合は、<br>
              こちらよりアカウント登録票をダウンロードいただき、<br>
              必要事項を記入の上、特約店にお渡しください。
            </p>

            <v-btn
              dark
              class="paid-btn mt-8"
              href="/有料アカウント登録票.xlsx"
              download
            >
              有料用紙印刷アカウント登録票
            </v-btn>
          </v-card>

          <div class="back-area mt-6">
            <router-link class="back-link" to="/sign_in">← ログイン画面に戻る</router-link>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'PaidRegistration',
}
</script>

<style lang="stylus" scoped>
.paid-page
  font-size 13px

.logo-area
  margin-bottom 20px

.logo
  margin-right 18px

.panel
  max-width 640px
  margin 0 auto

.panel-heading
  position relative
  text-align left
  color #2d5aa3
  font-size 18px
  font-weight bold
  padding-left 12px
  margin-bottom 12px
  border-left 5px solid #2d5aa3

.paid-card
  margin 0 auto

.paid-text
  text-align left
  font-size 14px
  margin-bottom 0

.paid-btn
  color white !important
  background-color #e17cc0 !important

.back-area
  text-align center

.back-link
  text-decoration underline
  font-size 13px
</style>
